module.exports = __webpack_public_path__ + "img/save_time_img_min.4ca3091f.png";